import React from 'react';
import ReactDOM from 'react-dom/client';
import { useTranslation } from 'react-i18next';
import './index.css';
import './i18n/i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import headerManager from './axiosMiddleware/HeaderManager';
import { HeaderProvider, useNotifications } from './axiosMiddleware/HeaderContext';
import { ProfileProvider } from './Providers/ProfileProvider';
import { LinksProvider } from './Providers/LinksProvider';
import OverQuotaModal from './components/quota/OverQuotaModal';

const root = ReactDOM.createRoot(document.getElementById('root'));

function HeaderManagerWrapper() {
  const { t } = useTranslation();
  const {
    notifications, setNotifications,
    overQuota, setOverQuota,
    overWorkspaceQuota, setOverWorkspaceQuota,
  } = useNotifications();
  const [ready, setReady] = React.useState(false);
  const addNotification = (el) => setNotifications([...notifications, el]);
  React.useEffect(() => {
    headerManager(addNotification, setOverQuota, setOverWorkspaceQuota);
    setReady(true);
  }, []);
  if (!ready) return null;

  return (
    <>
      <App />
      {overQuota && (
        <OverQuotaModal
          workspaceDomain={overQuota.workspaceDomain}
          currentCount={overQuota.currentCount}
          maxAllowed={overQuota.maxAllowed}
          isOwner={overQuota.isOwner}
          onDone={() => setOverQuota(null)}
        />
      )}
      {overWorkspaceQuota && (
        <div style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.75)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
        }}
        >
          <div style={{
            background: 'var(--main1)',
            border: '1px solid var(--main1Border)',
            borderRadius: '12px',
            padding: '28px',
            maxWidth: '440px',
            width: '90%',
          }}
          >
            <div style={{
              display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px',
            }}
            >
              <div style={{
                width: '8px', height: '8px', borderRadius: '50%', background: 'var(--special-color)',
              }}
              />
              <h2 style={{ margin: 0, fontSize: '17px', color: 'var(--very-visible)' }}>
                {t('quota.workspacesLimitTitle')}
              </h2>
            </div>
            <p style={{
              margin: '0 0 20px', fontSize: '13px', color: 'var(--visible)', lineHeight: 1.6,
            }}
            >
              {t('quota.workspacesLimitDescription', {
                ownedCount: overWorkspaceQuota.ownedCount,
                maxAllowed: overWorkspaceQuota.maxAllowed,
                plural: overWorkspaceQuota.ownedCount > 1 ? 's' : '',
              })}
              {' '}
              {overWorkspaceQuota.isOwner
                ? t('quota.workspacesOwnerInstruction')
                : t('quota.workspacesNonOwnerInstruction')}
            </p>
            {overWorkspaceQuota.isOwner ? (
              <button
                type="button"
                onClick={() => {
                  setOverWorkspaceQuota(null);
                  window.location.href = '/profile';
                }}
                style={{
                  width: '100%',
                  padding: '10px 0',
                  background: 'var(--primary)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '6px',
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                {t('quota.manageWorkspaces')}
              </button>
            ) : (
              <button
                type="button"
                onClick={() => setOverWorkspaceQuota(null)}
                style={{
                  width: '100%',
                  padding: '10px 0',
                  background: 'var(--main2)',
                  color: 'var(--visible)',
                  border: '1px solid var(--main1Border)',
                  borderRadius: '6px',
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                {t('quota.understood')}
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
}

root.render(
  <React.StrictMode>
    <HeaderProvider>
      <ProfileProvider>
        <LinksProvider>
          <HeaderManagerWrapper />
        </LinksProvider>
      </ProfileProvider>
    </HeaderProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
